<template>
    <v-data-table
        v-if="items"
        fixed-header
        :headers="currentReportHeaders"
        :items="items"
        :loading="loading"
        :items-per-page="10"
        :hide-default-footer="false"
        :footer-props="{
            'items-per-page-options': [15, 30, 50, -1],
            'items-per-page-text': t('datatable::pagination.items.per.page.text'),
        }"
    >
        <template #[`item.patient.dms_id`]="{ item }">
            <div
                v-if="item.patient.dms_id && can('patients.preview')"
                class="link"
                @click="$root.goTo(patientsItemUrl(item.patient))"
            >
                {{ item.patient.dms_id ?? t('patients::label.deleted') }}
            </div>
            <div v-else>
                {{ item.patient.dms_id ?? t('patients::label.deleted') }}
            </div>
        </template>
        <template #[`item.reason`]="{ item }">
            <v-edit-dialog :ref="`editDialogReason${item.id}`" @save="saveItemRow(item)">
                <v-icon left>mdi-pencil</v-icon
                ><span class="grid-editable"> {{ item.reason || t('default::label.na') }} </span>
                <template #input>
                    <div class="form-minutes">
                        <div class="input-textarea">
                            <v-textarea
                                :ref="`editDialogInputCommentReason${item.id}`"
                                v-model="item.reason"
                                :label="t('reports::trackers.grid.label.reason')"
                                dense
                                outlined
                                rounded
                            ></v-textarea>
                        </div>
                        <div class="input-actions">
                            <v-tooltip top transition="v-fab-transition">
                                <template #activator="{ on, attrs }">
                                    <v-btn
                                        color="primary"
                                        icon
                                        v-bind="attrs"
                                        v-on="on"
                                        @click="fakeSaveItemRowReason(item)"
                                    >
                                        <v-icon>mdi-check</v-icon>
                                    </v-btn>
                                </template>
                                <span>{{ t('default::button.save') }}</span>
                            </v-tooltip>
                            <v-tooltip top transition="v-fab-transition">
                                <template #activator="{ on, attrs }">
                                    <v-btn
                                        color="disabled-color"
                                        icon
                                        v-bind="attrs"
                                        v-on="on"
                                        @click="closeDialog(item)"
                                    >
                                        <v-icon>mdi-close</v-icon>
                                    </v-btn>
                                </template>
                                <span>{{ t('default::button.close') }}</span>
                            </v-tooltip>
                        </div>
                    </div>
                </template>
            </v-edit-dialog>
        </template>
        <template #[`item.rechallenged_date`]="{ item }">
            {{
                item.rechallenged_date
                    ? moment(item.rechallenged_date).format($root.dateFormat)
                    : t('default::label.na')
            }}
        </template>
        <template #[`item.comment`]="{ item }">
            <v-edit-dialog :ref="`editDialogComment${item.id}`" @save="saveItemRow(item)">
                <v-icon left>mdi-pencil</v-icon
                ><span class="grid-editable"> {{ item.comment || t('default::label.na') }} </span>
                <template #input>
                    <div class="form-minutes">
                        <div class="input-textarea">
                            <v-textarea
                                :ref="`editDialogInputComment${item.id}`"
                                v-model="item.comment"
                                :label="t('reports::trackers.grid.label.comment')"
                                dense
                                outlined
                                rounded
                            ></v-textarea>
                        </div>
                        <div class="input-actions">
                            <v-tooltip top transition="v-fab-transition">
                                <template #activator="{ on, attrs }">
                                    <v-btn
                                        color="primary"
                                        icon
                                        v-bind="attrs"
                                        v-on="on"
                                        @click="fakeSaveItemRowComment(item)"
                                    >
                                        <v-icon>mdi-check</v-icon>
                                    </v-btn>
                                </template>
                                <span>{{ t('default::button.save') }}</span>
                            </v-tooltip>
                            <v-tooltip top transition="v-fab-transition">
                                <template #activator="{ on, attrs }">
                                    <v-btn
                                        color="disabled-color"
                                        icon
                                        v-bind="attrs"
                                        v-on="on"
                                        @click="closeDialog(item)"
                                    >
                                        <v-icon>mdi-close</v-icon>
                                    </v-btn>
                                </template>
                                <span>{{ t('default::button.close') }}</span>
                            </v-tooltip>
                        </div>
                    </div>
                </template>
            </v-edit-dialog>
        </template>
    </v-data-table>
</template>

<script>
export default {
    name: 'ReChallengedDataTable',
    components: {},
    data() {
        return {
            hiddenColumns: ['id'],
        };
    },
    computed: {
        loading: {
            get() {
                return this.$store.state.trackers.loading;
            },
            set(loading) {
                return this.$store.dispatch('trackers/setLoading', loading);
            },
        },
        currentReportHeaders() {
            const columns = [
                {
                    text: t('reports::trackers.grid.label.id'),
                    value: 'id',
                    sortable: false,
                    width: 170,
                },
                {
                    text: t('reports::trackers.grid.label.patient_id'),
                    value: 'patient.dms_id',
                    fields: 'patient',
                    sortable: true,
                    width: 120,
                },
                {
                    text: t('reports::trackers.grid.label.reason'),
                    value: 'reason',
                    sortable: true,
                    width: 300,
                },
                {
                    text: t('reports::trackers.grid.label.rechallenged_date'),
                    value: 'rechallenged_date',
                    sortable: true,
                    width: 150,
                },
                {
                    text: t('reports::trackers.grid.label.comment'),
                    value: 'comment',
                    sortable: true,
                    align: 'center',
                    width: 300,
                },
            ];
            return columns.filter((x) => !this.hiddenColumns.includes(x.value));
        },
        items() {
            return this.$store.state.trackers.currentReportItems;
        },
    },
    watch: {},
    mounted() {},
    methods: {
        closeDialog(item) {
            const commentDialog = this.$refs[`editDialogComment${item.id}`];
            const reasonDialog = this.$refs[`editDialogReason${item.id}`];
            if (commentDialog) {
                commentDialog.$emit('close');
                commentDialog.isActive = false;
            }
            if (reasonDialog) {
                reasonDialog.$emit('close');
                reasonDialog.isActive = false;
            }
        },
        fakeSaveItemRowReason(item) {
            this.$refs[`editDialogReason${item.id}`].save(item.reason);
            this.$refs[`editDialogReason${item.id}`].$emit('save');
        },
        fakeSaveItemRowComment(item) {
            this.$refs[`editDialogComment${item.id}`].save(item.comment);
            this.$refs[`editDialogComment${item.id}`].$emit('save');
        },
        saveItemRow(item) {
            const data = {
                data: {
                    id: item.id,
                    comment: item.comment,
                    reason: item.reason,
                },
            };
            axios
                .put(route('api.v1.trackers.rechallenged-patients.update'), { data })
                .then(() => {
                    this.$root.notify(
                        'info',
                        t('default::notification.success'),
                        t('reports::trackers.mhbu.item.updated')
                    );
                })
                .catch((error) => {
                    this.$root.notify('error', error.response.data.error);
                });
        },
        patientsItemUrl(item) {
            return route('patients.preview', { id: item.id });
        },
    },
};
</script>
